import { useCurrentWorkspace } from '@gripp/shared-logic';
import {
  AccountFilterScreen,
  AccountFilterScreenHandle,
  SlideAction,
  useSlideLayout,
  ViewMode,
} from '@gripp/shared-ui';
import { useRef } from 'react';
import { useNavigate } from 'react-router';
import { useParams } from 'react-router-dom';
import { HeaderResetButton } from '../../shared/components/headerResetButton/headerResetButton';
import { AccountsBase } from './accounts';

export const AccountsFilterPage = () => {
  const filterRef = useRef<AccountFilterScreenHandle>(null);
  const onBackButtonPressRef = useRef<(() => void) | undefined>(undefined);
  const { workspaceId } = useParams();
  const workspace = useCurrentWorkspace(true);
  const isInWorkspace = !!(workspaceId || workspace);

  const rightColumn = {
    title: 'people.menu.people',
    mainComponent: (
      <>
        <AccountFilterScreen
          ref={filterRef}
          mode="page"
          isVisible={true}
          isInWorkspace={isInWorkspace}
          bottomBar={() => <></>}
        />
        <BackHandlerRegistrar onBackButtonPressRef={onBackButtonPressRef} />
      </>
    ),
    headerComponent: (
      <HeaderResetButton onReset={() => filterRef.current?.onReset()} />
    ),
    showBackButton: true,
    onBackButtonPress: () => onBackButtonPressRef.current?.(),
  };

  return <AccountsBase rightColumn={rightColumn} viewMode={ViewMode.DUAL} />;
};

const BackHandlerRegistrar = ({
  onBackButtonPressRef,
}: {
  onBackButtonPressRef: React.MutableRefObject<(() => void) | undefined>;
}) => {
  const navigate = useNavigate();
  const { onSlideChange } = useSlideLayout();

  onBackButtonPressRef.current = async () => {
    await onSlideChange(SlideAction.SINGLE);
    navigate('/accounts');
  };

  return null;
};
